import React from 'react'

export default class VenmoUrl extends React.Component {
  constructor (props) {
    super(props)

    const username = this._getUrlParameter('username')

    this.state = {
      username
    }
  }

  _getUrlParameter (name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  _onChange (username) {
    this.setState({username})
  }

  render () {
    const { username } = this.state
    const amount = this.props.amount
    const note = 'Dinner paid with OneCard 💳'
    const url = `https://venmo.com/?txn=pay&audience=friends&recipients=${username}&amount=${amount}&note=${note}`

    return (
      <div>
        <p>
          <span>Venmo recipient: </span>
          <input type="text" placeholder="marcusmolchany" defaultValue={this.state.username} onChange={(node) => this._onChange(node.target.value)}/>
        </p>
        <a target="_blank" href={url}>Pay {username} ${amount.toFixed(2)}</a>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/components/VenmoUrl.js
 **/